import React, { useState } from "react";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import {
  GenerateQrCodesForm,
  QrCodesSheet,
  QrCodesList,
} from "../components";

export const QrCodes: React.FC = () => {
  const [generatedCodes, setGeneratedCodes] = useState<string[]>([]);

  return (
    <>
      <Header
        title="QR codes"
        subtitle="Générer des étiquettes PDF prêtes à imprimer"
      />
      <div className="main-container">
        <div className="card mb-4">
          <CardHeader title="Générer une nouvelle planche" />
          <GenerateQrCodesForm onGenerated={setGeneratedCodes} />
        </div>

        {generatedCodes.length > 0 && (
          <div className="card mb-4">
            <CardHeader title="Planche générée" />
            <QrCodesSheet codes={generatedCodes} />
          </div>
        )}

        <div className="card">
          <CardHeader title="Tous les QR codes" />
          <QrCodesList />
        </div>
      </div>
    </>
  );
};
